export default "__VITE_ASSET__BqnxHRLE__"